(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlexBlock);
  } else {
    initFlexBlock();
  }

  function initFlexBlock() {
    const flexBlocks = document.querySelectorAll('.flex-block');
    
    flexBlocks.forEach(function(flexBlock) {
      setupFlexBlock(flexBlock);
    });
  }

  function setupFlexBlock(container) {
    // Get the purchase type radio buttons
    const purchaseTypeRadios = container.querySelectorAll('input[name="flex-block-purchase-type"]');
    
    // Get the content sections
    const flexContent = container.querySelector('[data-flex-access]');
    const onetimeContent = container.querySelector('[data-onetime]');

    // If elements don't exist, exit early
    if (!purchaseTypeRadios.length || !flexContent || !onetimeContent) {
      return;
    }

    // Function to toggle visibility based on selected purchase type
   function togglePurchaseType() {
  const selectedType = container.querySelector(
    'input[name="flex-block-purchase-type"]:checked'
  );

  if (!selectedType) return;

  const features = document.querySelectorAll(
    '.product-block .product-features .feature'
  );

  if (selectedType.value === 'flex') {
    // Show flex content, hide onetime content
    flexContent.classList.remove('hidden');
    onetimeContent.classList.add('hidden');

    // Update price for flex product
    updatePriceForFlex(container);

    // Hide all features except the first one
    features.forEach((feature, index) => {
      if (index !== 0) {
        feature.style.display = 'none';
      }
    });

  } else if (selectedType.value === 'onetime') {
    // Hide flex content, show onetime content
    flexContent.classList.add('hidden');
    onetimeContent.classList.remove('hidden');

    // Revert price to original
    revertPriceToOriginal();

    // Show all features again
    features.forEach(feature => {
      feature.style.display = '';
    });
  }
}


    // Check for URL parameter to auto-select flex product (before setting initial state)
    autoSelectFlexProductFromUrl(container, flexContent, togglePurchaseType);

    // Set initial state based on checked radio button
    togglePurchaseType();

    // Listen for changes on purchase type radio buttons
    purchaseTypeRadios.forEach(function(radio) {
      radio.addEventListener('change', togglePurchaseType);
    });

    // Listen for changes on flex product selection
    const flexProductRadios = flexContent.querySelectorAll('input[name="flex-block-purchase-type-block-flex"]');
    flexProductRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        const selectedType = container.querySelector('input[name="flex-block-purchase-type"]:checked');
        if (selectedType && selectedType.value === 'flex') {
          updatePriceForFlex(container);
        }
      });
    });

    // Setup add to cart button
    setupAddToCartButton(container, flexContent, onetimeContent);
  }

  function autoSelectFlexProductFromUrl(container, flexContent, togglePurchaseType) {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const productHandle = urlParams.get('product_handle');
    
    // If no product_handle parameter, exit
    if (!productHandle) {
      return;
    }

    // Find the flex product radio button with matching data-product-handle
    const flexProductRadios = flexContent.querySelectorAll('input[name="flex-block-purchase-type-block-flex"]');
    let matchingRadio = null;
    
    for (let i = 0; i < flexProductRadios.length; i++) {
      const radioHandle = flexProductRadios[i].getAttribute('data-product-handle');
      if (radioHandle === productHandle) {
        matchingRadio = flexProductRadios[i];
        break;
      }
    }

    // If matching product found, select it
    if (matchingRadio) {
      // Select the flex purchase type radio button
      const flexPurchaseTypeRadio = container.querySelector('#flex-block-purchase-type-flex');
      if (flexPurchaseTypeRadio) {
        flexPurchaseTypeRadio.checked = true;
      }

      // Select the matching flex product radio button
      matchingRadio.checked = true;
      
      // Manually trigger toggle to update UI and price
      if (togglePurchaseType) {
        togglePurchaseType();
      }
    }
  }

  function updatePriceForFlex(container) {
    // Get the selected flex product radio button
    const selectedRadio = container.querySelector('input[name="flex-block-purchase-type-block-flex"]:checked');
    
    if (!selectedRadio) {
      return;
    }

    // Find the content element with the h5 tag
    const selectedBlock = selectedRadio.closest('.flex-block-purchase-type-content-item-block');
    const contentElement = selectedBlock ? selectedBlock.querySelector('.flex-block-purchase-type-content-item-content') : null;
    
    if (!contentElement) {
      return;
    }

    // Get the h5 tag
    const h5Tag = contentElement.querySelector('h5');
    
    if (!h5Tag) {
      return;
    }

    // Create a span element and copy content from h5
    const spanTag = document.createElement('span');
    spanTag.innerHTML = h5Tag.innerHTML;
    
    // Copy all attributes from h5 to span
    Array.from(h5Tag.attributes).forEach(function(attr) {
      spanTag.setAttribute(attr.name, attr.value);
    });

    // Find the parent .product-single__meta (use closest to traverse up the DOM)
    const productMeta = container.closest('.product-single__meta');
    
    if (!productMeta) {
      console.warn('product-single__meta not found');
      return;
    }

    // Find the price block (not the flex-price-block)
    const priceBlock = productMeta.querySelector('.product-block.product-block--price:not(.flex-price-block)');
    
    if (!priceBlock) {
      console.warn('Price block not found');
      return;
    }

    // Remove any existing flex price block
    const existingFlexPriceBlock = productMeta.querySelector('.product-block.product-block--price.flex-price-block');
    if (existingFlexPriceBlock) {
      existingFlexPriceBlock.remove();
    }

    // Hide the original price block
    priceBlock.classList.add('hidden');

    // Create new price block
    const newPriceBlock = document.createElement('div');
    newPriceBlock.className = 'product-block product-block--price flex-price-block';
    newPriceBlock.appendChild(spanTag);

    // Insert as sibling after the original price block
    priceBlock.parentNode.insertBefore(newPriceBlock, priceBlock.nextSibling);
  }

  function revertPriceToOriginal() {
    // Find all flex price blocks and remove them
    const flexPriceBlocks = document.querySelectorAll('.product-block.product-block--price.flex-price-block');
    flexPriceBlocks.forEach(function(block) {
      block.remove();
    });

    // Show the original price block(s) by removing hidden class
    const priceBlocks = document.querySelectorAll('.product-block.product-block--price:not(.flex-price-block)');
    priceBlocks.forEach(function(block) {
      if (block.classList.contains('hidden')) {
        block.classList.remove('hidden');
      }
    });
  }

  function setupAddToCartButton(container, flexContent, onetimeContent) {
    const addToCartButton = container.querySelector('.flex-block-cta button');
    
    if (!addToCartButton) {
      return;
    }

    addToCartButton.addEventListener('click', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      // Check which section is visible (not hidden)
      let visibleSection = null;
      let selectedRadio = null;
      let variantId = null;

      if (!flexContent.classList.contains('hidden')) {
        // Flex section is visible
        visibleSection = flexContent;
        selectedRadio = visibleSection.querySelector('input[name="flex-block-purchase-type-block-flex"]:checked');
        
        if (!selectedRadio) {
          console.error('No flex product selected');
          return;
        }

        // Get the selected variant title from the product size variant select
        const productSizeVariantSelect = document.querySelector('.product-size-variant select');
        
        if (!productSizeVariantSelect) {
          console.error('Product size variant select not found');
          return;
        }

        const selectedVariantTitle = productSizeVariantSelect.value;
        
        if (!selectedVariantTitle) {
          console.error('No variant title selected');
          return;
        }

        // Find the select element that is a sibling to the selected flex product block
        const selectedFlexProductBlock = selectedRadio.closest('.flex-block-purchase-type-content-item-block');
        let flexProductSelect = null;
        
        if (selectedFlexProductBlock) {
          // The select is a sibling, so we need to find it before the block
          // Traverse backwards from the block to find the select
          let sibling = selectedFlexProductBlock.previousElementSibling;
          while (sibling) {
            if (sibling.classList.contains('flex-block-purchase-type-content-item-select')) {
              flexProductSelect = sibling;
              break;
            }
            sibling = sibling.previousElementSibling;
          }
        }
        
        if (!flexProductSelect) {
          console.error('Flex product select not found');
          return;
        }

        // Find the option with matching data-label
        // Get all options and find the one with matching data-label
        const options = flexProductSelect.querySelectorAll('option');
        let matchingOption = null;
        
        for (let i = 0; i < options.length; i++) {
          if (options[i].getAttribute('data-label') === selectedVariantTitle) {
            matchingOption = options[i];
            break;
          }
        }
        
        if (!matchingOption) {
          console.error('No matching variant found for title: ' + selectedVariantTitle);
          return;
        }

        variantId = matchingOption.value;
        
      } else if (!onetimeContent.classList.contains('hidden')) {
        // Onetime section is visible
        visibleSection = onetimeContent;
        selectedRadio = visibleSection.querySelector('input[name="flex-block-purchase-type-block"]:checked');
        
        if (!selectedRadio) {
          console.error('No onetime product selected');
          return;
        }

        // Get the selected option from the product size variant select
        const productSizeVariantSelect = document.querySelector('.product-size-variant select');
        
        if (!productSizeVariantSelect) {
          console.error('Product size variant select not found');
          return;
        }

        const selectedOption = productSizeVariantSelect.options[productSizeVariantSelect.selectedIndex];
        
        if (!selectedOption) {
          console.error('No option selected in product size variant select');
          return;
        }

        // Get the variant ID from the data-id attribute
        variantId = selectedOption.getAttribute('data-id');
        
        if (!variantId) {
          console.error('No variant ID found in selected option');
          return;
        }
      }

      // If no variant ID found, exit
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Add loading state
      addToCartButton.disabled = true;
      addToCartButton.classList.add('btn--loading');
      const originalText = addToCartButton.textContent;
      addToCartButton.textContent = 'Adding...';

      // Prepare form data for Shopify cart API
      const formData = new URLSearchParams();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      // Add to cart using Shopify API
      const cartAddUrl = theme.routes ? theme.routes.cartAdd : '/cart/add.js';
      
      fetch(cartAddUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        // Reset button state
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('btn--loading');
        addToCartButton.textContent = originalText;

        if (data.status === 422) {
          // Error adding to cart
          console.error('Error adding to cart:', data.description || data.message);
          alert(data.description || 'Unable to add product to cart. Please try again.');
        } else {
          // Success - dispatch event for cart updates
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data,
              addToCartBtn: addToCartButton
            },
            bubbles: true
          }));

          // If cart type is page, redirect to cart
         // if (theme.settings && theme.settings.cartType === 'page') {
          //  const cartPageUrl = theme.routes ? theme.routes.cartPage : '/cart';
          //  window.location = cartPageUrl;
         // }
        }
      })
      .catch(function(error) {
        // Reset button state on error
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('btn--loading');
        addToCartButton.textContent = originalText;
        console.error('Error adding to cart:', error);
        alert('Unable to add product to cart. Please try again.');
      });
    });
  }
})();
